import { render, staticRenderFns } from "./big-event-edit.vue?vue&type=template&id=038c20ee&scoped=true&"
import script from "./big-event-edit.vue?vue&type=script&lang=js&"
export * from "./big-event-edit.vue?vue&type=script&lang=js&"
import style0 from "./big-event-edit.vue?vue&type=style&index=0&id=038c20ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c20ee",
  null
  
)

export default component.exports